import { Component, Input, OnInit } from '@angular/core';
import { Utils } from '@app/features/dashboard/utils/utils.service';

@Component({
  selector: 'app-presentation-card',
  templateUrl: './presentation-card.component.html',
  styleUrls: ['./presentation-card.component.scss']
})
export class PresentationCardComponent implements OnInit {

  @Input() text: string;
  @Input() subtext: string;
  @Input() total: number;
  @Input() color?: string;

  constructor(
    public utils: Utils,
  ) { }

  ngOnInit() {
  }

  displayActiveness(): string {
    if (this.color) {
      return this.color;
    }

    return this.utils.isNegativeValue(this.total) ? 'red' : 'green';
  }
}
